module.exports = __webpack_public_path__ + "static/media/facebook.5d2305e0.svg";